import {
  ChangeDetectorRef,
  Component,
  AfterViewInit,
  Injector,
  HostListener,
  OnInit,
  OnDestroy,
  Inject
} from '@angular/core';
import { interval, Observable, firstValueFrom, Subscription } from 'rxjs';
import { DataService } from './services/data.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AppConfig } from './constants/app-config';
import { TranslateService } from '@ngx-translate/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { ThemeSwitcherService } from './services/theme-switcher.service';
import { CotizadorService } from './services/cotizador.service';
import { KeycloakService } from 'keycloak-angular';
import { NavigationEnd, Router } from '@angular/router';
import { ModalService } from './services/modal-service.service';
import { Icons } from './components/modal-alert/enums';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { NgcCookieConsentService, NgcStatusChangeEvent } from 'ngx-cookieconsent';
import { SeoService } from './services/seo.service';
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { MissingDataRegisterComponent } from './components/missing-data-register/missing-data-register.component';
import { LogService } from './services/log.service';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import * as _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports
import { default as _rollupMoment } from 'moment';
import dataConfig from './../assets/config.json';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DOCUMENT } from '@angular/common'
import { WINDOW } from './utils/window';
import { KeycloakCustomService } from './services/keycloak-custom.service';
import { KeyclockProfile } from './model/http/keyclock.model'
import { ErrorBuro } from './utils/utils';
const moment = _rollupMoment || _moment;
import { datadogRum, DefaultPrivacyLevel } from '@datadog/browser-rum'
import { RegisterService } from './services/register.service';


// See the Moment.js docs for the meaning of these formats:
// https://momentjs.com/docs/#/displaying/format/
export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
  title = 'my-app';
  now = new Date();
  isLoading!: Observable<boolean>;

  userObject!: KeyclockProfile;
  idKeycloak: any;
  processActive: boolean = false;
  storage: any;
  //injectors
  matIcon: MatIconRegistry;
  dom: DomSanitizer;
  themeSwitcher: ThemeSwitcherService;
  translate: TranslateService;
  router: Router;
  modalService!: ModalService;

  screenSize = this.window.innerWidth;
  gtmService: GoogleTagManagerService;
  source = interval(1000);
  ccService: NgcCookieConsentService;
  keycloackService: KeycloakService;
  keycloackCustomService: KeycloakCustomService;
  seoService: SeoService;
  logService: LogService;
  dialog: MatDialog;
  httpClient: HttpClient;
  snackBar: MatSnackBar;
  registerService: RegisterService;

  templateSuffix = environment.templateSuffix;
  isBlocked = false;
  config!: string;
  storageType: string | null = null;

  gclid: string | null = null; // Variable para almacenar el valor


  private statusChangeSubscription!: Subscription;

  constructor(
    public dataService: DataService,
    private cdRef: ChangeDetectorRef,
    private cotizadorService: CotizadorService,
    @Inject(DOCUMENT) private document: any,
    @Inject(WINDOW) private window: Window,
    private injector: Injector,
  ) {
    this.httpClient = this.injector.get<HttpClient>(HttpClient);
    this.gtmService = this.injector.get<GoogleTagManagerService>(
      GoogleTagManagerService
    );
    this.matIcon = this.injector.get<MatIconRegistry>(MatIconRegistry);
    this.dom = this.injector.get<DomSanitizer>(DomSanitizer);
    this.themeSwitcher =
      this.injector.get<ThemeSwitcherService>(ThemeSwitcherService);
    this.translate = this.injector.get<TranslateService>(TranslateService);
    this.router = this.injector.get<Router>(Router);
    this.modalService = this.injector.get<ModalService>(ModalService);
    this.ccService = this.injector.get<NgcCookieConsentService>(
      NgcCookieConsentService
    );
    this.dialog = this.injector.get<MatDialog>(MatDialog);
    this.seoService = this.injector.get<SeoService>(SeoService);
    this.logService = this.injector.get<LogService>(LogService);
    this.keycloackService = this.injector.get<KeycloakService>(KeycloakService);
    this.keycloackCustomService = this.injector.get<KeycloakCustomService>(KeycloakCustomService);
    this.snackBar = this.injector.get<MatSnackBar>(MatSnackBar);
    this.registerService = this.injector.get<RegisterService>(RegisterService);

    this.logService.disableConsoleInProduction();

    this.setupCustomIcons();
    this.translate.setDefaultLang('es');

    this.seoService.updateMetaTag({
      property: 'og:url',
      content: environment.keycloak.redirectUri,
    });
    this.seoService.updateMetaTag({
      name: 'twitter:url',
      content: environment.keycloak.redirectUri,
    });

    if (!environment.production) {
      this.seoService.updateMetaTag({
        name: 'robots',
        content: 'noindex, nofollow',
      });
    }

    this.dataService.getGeneralNotificationMessage().subscribe((msg) => {
      this.snackBar.open(msg, 'OK', {
        duration: AppConfig.generalMessageTimeout,
      });
    });

    this.dataService
      .getIsBlockedForContracts()
      .subscribe((res) => (this.isBlocked = res));

    this.getUser();

    this.initDataDog(environment.production);

    localStorage.setItem('flowType', environment.templateSuffix !== '' ? 'B' : 'A');
  }

  async ngOnInit() {

    this.storageType = localStorage.getItem('flowType');
    if (this.getCookie('cookieconsent_status') !== null) {
      this.ccService.destroy();
      this.ccService.fadeOut();
    }

    this.statusChangeSubscription = this.ccService.statusChange$.subscribe(
      (event: NgcStatusChangeEvent) => {
        let now = new Date();
        let time = now.getTime();
        let expireTime = time + 3600000 * 24 * 59;
        now.setTime(expireTime);
        this.document.cookie = `cookieconsent_status=ok;expires=${now.toUTCString()};path=/`;
      });

    this.config = dataConfig[0].version;

    this.router.events.subscribe((ev: any) => {
      if (ev instanceof NavigationEnd) {
        this.window.scrollTo(0, 0);
        this.window.scrollTo(0, 0);
        if(environment.production){
          const gtmTag = {
            event: 'page',
            pageName: ev.url,
          };
          this.gtmService.pushTag(gtmTag);
        }
        if (
          ev.url !== '/genera-oportunidad' &&
          this.idKeycloak &&
          !this.processActive
        )
          this.getProcess(this.idKeycloak, false);

        const headers = new HttpHeaders()
          .set('Cache-Control', 'no-cache, no-store, must-revalidate, post-check=0, pre-check=0')
          .set('Pragma', 'no-cache')
          .set('Expires', '0');

        const obs = this.httpClient
          .get<{ version: string }>("assets/config.json", { headers })
          .subscribe((config: any) => {
            if (config[0].version !== this.config) {
              location.reload();
            }

            obs.unsubscribe();
          });
      }
    });

    // Obtener el parámetro "gclid" de la URL
    const urlParams = new URLSearchParams(window.location.search);
    this.gclid = urlParams.get('gclid');

    // Si existe en la URL, guardarlo en localStorage
    if (this.gclid) {
        window.localStorage.setItem('gclid', this.gclid);
        console.log('Valor de gclid:', this.gclid); // Verificar en la consola
    } else {
      this.window.localStorage.removeItem('gclid');
    }
  }

  ngAfterViewInit(): void {
    this.cdRef.detectChanges();
  }

  changeLanguage(lang: string): void {
    this.translate.use(lang);
  }

  changeTheme(theme: string): void {
    this.themeSwitcher.loadTheme(theme);
  }

  private setupCustomIcons(): void {
    this.matIcon.addSvgIcon(
      'mex',
      this.dom.bypassSecurityTrustResourceUrl('./assets/img/lang/mex.svg')
    );
    this.matIcon.addSvgIcon(
      'usa',
      this.dom.bypassSecurityTrustResourceUrl('./assets/img/lang/usa.svg')
    );
  }


  getCookie(name: string) {
    let dc = this.document.cookie;
    let prefix = name + "=";
    let begin = dc.indexOf("; " + prefix);
    let end;
    if (begin == -1) {
      begin = dc.indexOf(prefix);
      if (begin != 0) return null;
    }
    else {
      begin += 2;
      end = this.document.cookie.indexOf(";", begin);
      if (end == -1) {
        end = dc.length;
      }
    }

    return decodeURI(dc.substring(begin + prefix.length, end));
  }

  async getUser() {
    const isLoggedInSalesforce = this.keycloackCustomService.isLoggin();
    if (isLoggedInSalesforce) {
      this.keycloackCustomService.loadSalesforceUserProfile().subscribe(async (user) => {
        try {
          if (!user.enabled || !user.emailVerified) {
            this.keycloackCustomService.logout();
            await this.modalService.showAlertWithoutIds('Usuario inactivo', Icons.error, false, '');
            return;
          }
          const isSalesforce = await firstValueFrom(this.keycloackCustomService.isUserSalesforce(user.id));
          if (!isSalesforce) {
            this.keycloackCustomService.logout();
            await this.modalService.showAlertWithoutIds('Usuario no permitido', Icons.error, false, '');
            return;
          }

          const email = this.keycloackCustomService.clientEmailSupport!;
          await this.getProcess(email, true, true, true);
          if (!this.processActive) {
            this.keycloackCustomService.logout();
            await this.modalService.showAlertWithoutIds(`No hay proceso para ${email}`, Icons.error, false, '');
            return;
          }
          this.dataService.setIsLoged(isLoggedInSalesforce);
          this.userObject = user;
          this.dataService.setIdKeycloak(email);
          this.idKeycloak = email;
        } catch (error) {
          this.keycloackCustomService.logout();
        }

      });
    } else {
      const logged = await this.keycloackService.isLoggedIn();//.then((logged) => {
      this.dataService.setIsLoged(logged);
      if (!logged) {
        return;
      }
      this.keycloackService.loadUserProfile().then((user) => {

        this.userObject = user;
        this.dataService.setIdKeycloak(this.userObject.email);
        this.dataService.setPersontype(this.userObject?.attributes?.persontype !== undefined ? this.userObject?.attributes?.persontype[0] : '');
        if (!this.userObject?.attributes?.persontype && this.storageType === 'B') {
          this.updateUserAttributesB(user);
          this.dataService.setPersontype("PFA");
        }
        this.idKeycloak = this.userObject.email;
        this.checkAttributesUser(user);

        this.getProcess(this.idKeycloak, true);
      });
    }
  }

  alertProcess(res: any) {
    if (
      this.router.url.includes('genera-oportunidad') ||
      this.router.url.includes('landing') ||
      this.router.url.includes('read-qr') ||
      this.router.url.includes('download') ||
      this.router.url.includes('comparar-unidad')
    ) {
      return;
    }

    if (res.client?.E7?.data?.errors && res.client?.E7?.data?.errors[0]?.cveError === ErrorBuro.NO_HISTORIAL) {
      return;
    }

    const msg = `¡Tienes un proceso de ${res.client.product.concept} para tu <strong> ${res.car.brand} - ${res.car.subBrand} </strong> en curso! `;
    this.modalService
      .openAlert(
        {
          title: '¡Aviso!',
          content: msg,
          btnAction1: 'Revisar su estatus',
          btnAction2: 'Cancelar',
          icon: Icons.none,
          idBtnAction1: `boton-aviso-revisar-estatus${this.templateSuffix !== '' ? '-b' : ''
            }`,
          idBtnAction2: `boton-aviso-cancelar-revisar-status${this.templateSuffix !== '' ? '-b' : ''
            }`,
        },
        true
      )
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          this.router.navigate(['/genera-oportunidad']);
          sessionStorage.setItem('aceptProcess', 'true');
        }
      });
  }

  cancelProcessModalNoti(msg: string) {
    this.modalService
      .openAlert(
        {
          title: '¡Aviso!',
          content: msg,
          btnAction1: 'Aceptar',
          btnAction2: null,
          icon: Icons.none,
          idBtnAction1: '',
          idBtnAction2: '',
        },
        true
      )
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          this.router.navigate(['/buscador']);
          sessionStorage.setItem('aceptProcess', 'true');
        }
      });
  }

  async getProcess(idKeycloak: any, showAlert: boolean, forceRedirect: boolean = false, validate: boolean = false) {
    const res = await firstValueFrom(this.cotizadorService.existingProcesses(idKeycloak));

    let active = this.finishProcessAndQuoter(res);
    if (active.carInactive && active.beforeStepToSearchCar) {
      this.cancelProcessModalNoti(
        `Lamentablemente el <strong> ${res.car.brand} - ${res.car.subBrand} - ${res.car.version}</strong> ya no es parte de nuestro catálogo. <br> Te invitamos a seleccionar un nuevo vehículo.`
      );
      this.processActive = false;
    } else if (res.step > 0) {
      if (forceRedirect) {
        this.router.navigate(['/genera-oportunidad']);
        sessionStorage.setItem('aceptProcess', 'true');
      } else if (showAlert) {
        this.alertProcess(res);
      }
      this.processActive = true;
    }
  }

  finishProcessAndQuoter(res: any) {
    let obj = {
      carInactive: false,
      beforeStepToSearchCar: false,
    };

    // verificar si el auto esta activado y si el estado es inferior a E23 busqueda de auto
    if (
      res.car !== undefined &&
      res.car.isActive !== undefined &&
      !res.car.isActive &&
      res.step < 23
    ) {
      let ofDesactiveCar = true;
      let id = res.client.id;
      this.cotizadorService
        .finishProccesAndQuoter(id, ofDesactiveCar)
        .subscribe((resonse: any) => console.log(resonse));
      obj.carInactive = true;
      obj.beforeStepToSearchCar = true;
    }
    return obj;
  }

  async checkAttributesUser(user: any) {
    let isFlowB = false;
    let storageType = localStorage.getItem('flowType');
    isFlowB = storageType === 'B' ? true : false;
    if (user.attributes.flowType) {
      if (user.attributes.flowType[0] === 'B') this.redirectB();
      else this.redirectA();
    } else {

      if (this.storageType === 'B') this.redirectB();
      else this.redirectA();
    }
    this.checkMissingData(user, isFlowB);
  }

  /**
   * Revisa si el usuario tiene todos los datos completos de registro
   * Esto es por si inicia a travez de redes sociales.
   * Si es Flujo A solicitara cargar los datos faltantes
   * Si es Flujo B los cargara automaticamente el dato faltante que es el persontype (FORD: Campaign)
   * @param {*} user
   * @param {boolean} isFlowB
   * @return {*}
   * @memberof AppComponent
   * @author victor.mendez
   */
  async checkMissingData(user: any, isFlowB: boolean) {
    const isCompleteData = user.attributes.hasOwnProperty('persontype');
    if (isFlowB) {
      if (!isCompleteData) {
        await this.updateUserAttributesB(user);
      }
    } else {
      if (!isCompleteData) {
        await this.fillMissingData(user.id);
      }
    }
  }

  /**
   * Actualiza el atributo persontype del usuario
   * Solo Aplica para Flujo B y Campaña FORD
   * @private
   * @param {*} user
   * @memberof AppComponent
   */
  private updateUserAttributesB(user: any): void {

    const body = { ...user.attributes, "persontype": "PFA" };
    this.registerService.updateUserAttributes(body, user.id).subscribe({
      next: () => console.log("se ejecuto el update Atributos B")
    });
  }

  async fillMissingData(idUser: string) {
    const dialog = this.dialog.open(MissingDataRegisterComponent, {
      data: { idUser },
      disableClose: true,
    });

    const resp = await firstValueFrom(dialog.afterClosed());
    return resp.persontype;
  }

  redirectA() {
    if (this.templateSuffix !== '')
      this.redirectTo(`${environment.baseUrl}/v1`, false);
  }

  redirectB() {
    if (this.templateSuffix === '')
      this.redirectTo(`${environment.baseUrl}/v2`, false);
  }

  redirectTo(url: string, logoout: boolean) {
    if (logoout) {
      sessionStorage.clear();
      localStorage.clear();
      this.keycloackService.logout(url);
    } else {
      let pathName = location.pathname.replace('/v1', '').replace('/v2', '');
      let queryParams = location.search;
      window.location.href = url + pathName + queryParams; 
      //?location.replace(url + pathName + queryParams);
    }
  }

  @HostListener('window:resize')
  onResize() {
    this.dataService.setInteractionUserPanel(false);
    this.dataService.setScreenSize(this.window.innerWidth);
    this.dataService.setScreenSize(this.window.innerWidth);
  }


  initDataDog(prod: boolean) {
    if (prod) {
      datadogRum.init({
        applicationId: environment.dataDog.applicationId,
        clientToken: environment.dataDog.clientToken,
        site: environment.dataDog.site,
        service: environment.dataDog.service,
        env: environment.dataDog.env,
        // version: environment.dataDog.version,
        sessionSampleRate: environment.dataDog.sessionSampleRate,
        sessionReplaySampleRate: environment.dataDog.sessionReplaySampleRate,
        trackUserInteractions: environment.dataDog.trackUserInteractions,
        trackResources: environment.dataDog.trackResources,
        trackLongTasks: environment.dataDog.trackLongTasks,
        defaultPrivacyLevel: environment.dataDog.defaultPrivacyLevel as DefaultPrivacyLevel
      });
    }
  }


  ngOnDestroy(): void {
    this.statusChangeSubscription.unsubscribe();
  }
}
